import { useNavigate } from 'react-router-dom';
import GradientBorder from '../../ui/GradientBorder';

import Loader from '../../ui/Loader';
import WhiteCard from '../../ui/WhiteCard';

import EmptyArray from '../../ui/EmptyArray';
import { useEffect, useRef } from 'react';
import { useHome } from '../../contexts/HomeContext';
import ArrowRight from '../../assets/icons/ArrowRight';
import ArrowLeft from '../../assets/icons/ArrowLeft';
import Button from '../../ui/Button';
import ButtonNew from '../../ui/ButtonNew';

const MyCollection = () => {
    const navigate = useNavigate();
    const { state: homeState, dispatch, loading } = useHome();
    const scrollCards = useRef();
    const { greenPillNFTsHoldByWalletAddress } = homeState;

    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }

    return (
        <div className=" mt-7 ">
            <div className="">
                <div className="relative ">
                    <WhiteCard bg={'bg-bgCollection'} verticalMargin="" className="px-5 py-4  ">
                        <div className={`h-full w-36 bg-right-gradient  absolute top-0 right-0 z-10 `}></div>
                        <h1
                            className="text-xl font-semibold text-tSecondary mb-3"
                            style={{
                                textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                            }}
                        >
                            {`My collection (${greenPillNFTsHoldByWalletAddress?.length ? greenPillNFTsHoldByWalletAddress?.length : 0
                                })`}
                        </h1>

                        <div
                            ref={scrollCards}
                            className="flex items-center overflow-x-auto    flex-nowrap   scrollableCards"
                        >
                            {loading ? (
                                <div className="h-52 w-full flex items-center justify-center">
                                    <Loader color={'fill-[#326F58]'} />
                                </div>
                            ) : greenPillNFTsHoldByWalletAddress.length > 0 ? (
                                greenPillNFTsHoldByWalletAddress.map((nft) => {
                                    return (
                                        <div
                                            // onClick={() => {
                                            //     navigate(
                                            //         `fund?nft=${
                                            //             nft?.collectionNo?.toString() + nft?.tokenId?.toString()
                                            //         }`
                                            //     );

                                            //     dispatch({
                                            //         type: 'home/setActiveCollection',
                                            //         payload: nft?.collectionNo,
                                            //     });
                                            // }}
                                            key={nft?.collectionNo + Math.random()}
                                            className={`container cursor-pointer flex flex-col gap-[.375rem]  rounded-lg w-48  bg-bgCollectionCard py-4  mr-5`}
                                        >
                                            <div className="flex items-center w-48 relative  justify-center">
                                                <img
                                                    className="w-[1.6rem] h-[1.6rem] absolute top-0 right-3 "
                                                    src={nft?.chainImage}
                                                    alt="chain-image"
                                                />
                                                <img className="w-full" src={nft?.imageURI} alt="greenpill-card" />
                                            </div>
                                            <p className="text-center font-semibold text-sm">{nft?.name}</p>

                                            {/* <div className="w-[80%] mx-auto">progress</div> */}
                                        </div>
                                    );
                                })
                            ) : (
                                <EmptyArray />
                            )}
                        </div>
                    </WhiteCard>
                    <ButtonNew
                        onClick={scrollL}
                        variant="closeNeutral"
                        size="xs"
                        shape="oval"
                        className="absolute top-[50%] translate-y-[-50%]   translate-x-[-50%] -left-0 py-3 "
                        fixedMinWidth
                        minWidthClass="min-w-[2.5rem]"
                    >
                        <ArrowLeft fillColor="#868686" />
                    </ButtonNew>
                    <ButtonNew
                        onClick={scrollR}
                        variant="closeNeutral"
                        size="xs"
                        shape="oval"
                        className="absolute absolute top-[50%] z-20 translate-y-[-50%] translate-x-[50%]  -right-0  py-3 "
                        fixedMinWidth
                        minWidthClass="min-w-[2.5rem]"
                    >
                        <ArrowRight fillColor={'#868686'} />
                    </ButtonNew>


                </div>
            </div>
        </div>
    );
};

export default MyCollection;
